import defaultState from "./state";
import { inArrayCheckCode } from "./functions";


const encuestaReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "LOAD_QUESTIONARY":
      return {
        ...state,
        encuestaData: action.encuestaData,
        encuestaResponses: [],
      };

    case "ADD_RESPONSE_QUESTIONARY":
      var encuestaResponses = state.encuestaResponses;
      var respuestaNueva = {};
      // ya está mi respuesta
      if (inArrayCheckCode(state.encuestaResponses, action.pregunta.codeQuestion)) {
        switch (action.pregunta.type) {
          case "JUST_ONE":
            // solo debo almacenar uno, entonces elimino el que está actualmente
            encuestaResponses = encuestaResponses.filter((er) => er.code !== action.pregunta.codeQuestion);
            respuestaNueva = {
              code: action.pregunta.codeQuestion,
              response: Object.keys(action.respuesta),
              type: action.pregunta.type,
            };
            break;
          case "AT_LEAST_ONE":
            // debo editar el arreglo de las respuestas, para que almacene el nuevo que llega.
            for (let i = 0; i < encuestaResponses.length; i++) {
              if (encuestaResponses[i].code === action.pregunta.codeQuestion) {
                var newResponse = encuestaResponses[i].response.concat(Object.keys(action.respuesta)[0]);
                break;
              }
            }
            encuestaResponses = encuestaResponses.filter((er) => er.code !== action.pregunta.codeQuestion);
            respuestaNueva = {
              code: action.pregunta.codeQuestion,
              response: newResponse,
              type: action.pregunta.type,
            };
            break;
          default:
            return {
              ...state,
            };
        }
      } else {
        respuestaNueva = {
          code: action.pregunta.codeQuestion,
          response: Object.keys(action.respuesta),
          type: action.pregunta.type,
        };
      }
      return {
        ...state,
        encuestaResponses: encuestaResponses.concat(respuestaNueva),
      };


    case "REMOVE_RESPONSE_QUESTIONARY":
      var encuestaResponses = state.encuestaResponses;
      var respuestaNueva = {};
      // recorro y busco la pregunta que debería quitar
      for (let i = 0; i < encuestaResponses.length; i++) {
        if (encuestaResponses[i].code === action.pregunta.codeQuestion) {
          var newResponse = encuestaResponses[i].response.filter((r) => r !== Object.keys(action.respuesta)[0]);
          break;
        }
      }
      encuestaResponses = encuestaResponses.filter((er) => er.code !== action.pregunta.codeQuestion);
      respuestaNueva = {
        code: action.pregunta.codeQuestion,
        response: newResponse,
        type: action.pregunta.type,
      };
      return {
        ...state,
        encuestaResponses: encuestaResponses.concat(respuestaNueva),
      };


    case "ADD_COMPOSITE_QUESTIONARY":
      var encuestaResponses = state.encuestaResponses;
      var respuestaNueva = {};
      var newResponse = [];
      var newResponseAdicional = [];
      if (inArrayCheckCode(state.encuestaResponses, action.pregunta.codeQuestion)) {
        for (let i = 0; i < encuestaResponses.length; i++) {
          if (encuestaResponses[i].code === action.pregunta.codeQuestion) {
            for (let j = 0; j < encuestaResponses[i].response.length; j++) {
              if (encuestaResponses[i].response[j] !== Object.keys(action.respuesta)[0]) {
                newResponse = newResponse.concat(encuestaResponses[i].response[j]);
                newResponseAdicional = newResponseAdicional.concat(encuestaResponses[i].responseadicional[j]);
              }
            }
            if (action.texto !== null && action.texto !== "") {
              newResponse = newResponse.concat(Object.keys(action.respuesta)[0]);
              newResponseAdicional = newResponseAdicional.concat(action.texto);
            }
            break;
          }
        }
        encuestaResponses = encuestaResponses.filter((er) => er.code !== action.pregunta.codeQuestion);
        respuestaNueva = {
          code: action.pregunta.codeQuestion,
          response: newResponse,
          responseadicional: newResponseAdicional,
          type: action.pregunta.type,
        };
      } else {
        respuestaNueva = {
          code: action.pregunta.codeQuestion,
          response: Object.keys(action.respuesta),
          responseadicional: [action.texto],
          type: action.pregunta.type,
        };
      }
      return {
        ...state,
        encuestaResponses: encuestaResponses.concat(respuestaNueva),
      };


    case "ADD_NUMBER_QUESTIONARY":
    case "ADD_TEXT_QUESTIONARY":
      var encuestaResponses = state.encuestaResponses.filter((er) => er.code !== action.pregunta.codeQuestion);
      var respuestaNueva = {};
      // siempre que cambie lo elimino... así me aseguro que no se dupliquen valores
      if (action.texto !== "" && action.texto !== null) {
        // si no viene vacío, lo agrego
        respuestaNueva = {
          code: action.pregunta.codeQuestion,
          response: [action.texto],
          type: action.pregunta.type,
        };
        encuestaResponses = encuestaResponses.concat(respuestaNueva);
      }
      return {
        ...state,
        encuestaResponses,
      };

    case "LOADING_SEND_QUESTIONARY":
      return {
        ...state,
        isLoading: action.isLoading,
      };

    case "RESET_RESPONSES_QUESTIONARY":
      return {
        ...state,
        encuestaResponses: [],
      };

    default:
      return {
        ...state,
      };
  }
};
export default encuestaReducer;
